/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

export interface AppMappings {
  statoPratica: Record<string, string>;
  normativa: Record<string, string>;
  area: Record<string, string>;
  profilo: Record<string, string>;
  tipoDocumento: Record<string, string>;
  statoRequisito: Record<string, string>;
}

@Injectable({
  providedIn: 'root',
})
export class MappingService {
  private mappings: AppMappings | null = null;
  private readonly assetsPath = 'assets/mappings';

  constructor(private http: HttpClient) {}

  public loadMappings(): Observable<any> {
    return forkJoin({
      statoPratica: this.http.get<Record<string, string>>(`${this.assetsPath}/statoPratica.json`).pipe(catchError(() => of({}))),
      normativa: this.http.get<Record<string, string>>(`${this.assetsPath}/normativa.json`).pipe(catchError(() => of({}))),
      area: this.http.get<Record<string, string>>(`${this.assetsPath}/area.json`).pipe(catchError(() => of({}))),
      profilo: this.http.get<Record<string, string>>(`${this.assetsPath}/profilo.json`).pipe(catchError(() => of({}))),
      tipoDocumento: this.http.get<Record<string, string>>(`${this.assetsPath}/tipoDocumento.json`).pipe(catchError(() => of({}))),
      statoRequisito: this.http.get<Record<string, string>>(`${this.assetsPath}/statoRequisito.json`).pipe(catchError(() => of({}))),

    }).pipe(
      tap((loadedMappings) => {
        this.mappings = loadedMappings as AppMappings;
      }),
      map(() => true)
    );
  }

  public getMappingValue(
    type: keyof AppMappings,
    id: string | number | null | undefined
  ): string {
    if (id === null || id === undefined) {
      return '';
    }

    const idString = String(id);

    if (!this.mappings || !this.mappings[type]) {
      return idString;
    }

    return this.mappings[type][idString] || idString;
  }

  public getMappingMap(
    type: keyof AppMappings
  ): Record<string, string> {
    return this.mappings && this.mappings[type] ? this.mappings[type] : {};
  }
  public getAll(type: keyof AppMappings): Record<string,string> {
  return this.mappings?.[type] ?? {};
}
}
